var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Injectable, Inject } from "@angular/core";
import { Http, RequestOptions, ConnectionBackend } from "@angular/http";
import { XHRBackendFactory } from "./XHRBackendFactory";
import { HTTP_FACTORY } from "./http-factory.token";
var ProgressHttp = ProgressHttp_1 = (function (_super) {
    __extends(ProgressHttp, _super);
    function ProgressHttp(xhrBackendFactory, requestOptions, httpFactory, backend) {
        var _this = _super.call(this, null, requestOptions) || this;
        _this.xhrBackendFactory = xhrBackendFactory;
        _this.requestOptions = requestOptions;
        _this.httpFactory = httpFactory;
        _this._uploadCallback = null;
        _this._downloadCallback = null;
        _this.http = httpFactory.create(backend, requestOptions);
        return _this;
    }
    ProgressHttp.prototype.request = function (url, options) {
        return this.http.request(url, options);
    };
    ProgressHttp.prototype.withDownloadProgressListener = function (listener) {
        this._downloadCallback = listener;
        return this._buildProgressHttpInstance();
    };
    ProgressHttp.prototype.withUploadProgressListener = function (listener) {
        this._uploadCallback = listener;
        return this._buildProgressHttpInstance();
    };
    ProgressHttp.prototype._buildProgressHttpInstance = function () {
        var progressHttp = new ProgressHttp_1(this.xhrBackendFactory, this.requestOptions, this.httpFactory, this._buildXHRBackend());
        progressHttp._uploadCallback = this._uploadCallback;
        progressHttp._downloadCallback = this._downloadCallback;
        return progressHttp;
    };
    ProgressHttp.prototype._buildXHRBackend = function () {
        var backend = this.xhrBackendFactory.create(this._uploadCallback, this._downloadCallback);
        return backend;
    };
    return ProgressHttp;
}(Http));
ProgressHttp = ProgressHttp_1 = __decorate([
    Injectable(),
    __param(2, Inject(HTTP_FACTORY)),
    __metadata("design:paramtypes", [XHRBackendFactory,
        RequestOptions, Object, ConnectionBackend])
], ProgressHttp);
export { ProgressHttp };
var ProgressHttp_1;
//# sourceMappingURL=progress-http.service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-progress-http/lib/progress-http.service.js
// module id = 165
// module chunks = 3